import { render, staticRenderFns } from "./questionAdd.vue?vue&type=template&id=523a854b&scoped=true&"
import script from "./questionAdd.vue?vue&type=script&lang=js&"
export * from "./questionAdd.vue?vue&type=script&lang=js&"
import style0 from "./questionAdd.vue?vue&type=style&index=0&id=523a854b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a854b",
  null
  
)

export default component.exports